// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cancel-pickup-modal__content[data-v-02b5b0a9]{max-width:370px;margin:40px auto 0}@media(max-width:460px){.cancel-pickup-modal__content>img[data-v-02b5b0a9]{width:270px}}", ""]);
// Exports
module.exports = exports;
